// import {apiAction} from './helper';

export const SET_FILTER_NODE_TYPE_VERSIONS = 'SET_FILTER_NODE_TYPE_VERSIONS';
export const RECALCULATE_FILTERS = 'RECALCULATE_FILTERS';
export const SET_FILTER_NODE_TYPE_VERSION_VALUE = 'SET_FILTER_NODE_TYPE_VERSION_VALUE';
export const SET_FILTER_REDUCER_PROPS = 'SET_FILTER_REDUCER_PROPS';
export const SET_FILTER_REDUCER_PROPS_AND_RECALC = 'SET_FILTER_REDUCER_PROPS_AND_RECALC';
export const RESET_FILTERS = 'RESET_FILTERS';
export const ADD_SINGLE_NODE_TYPE_VERSION = 'ADD_SINGLE_NODE_TYPE_VERSION';
